import { findNextIndex } from "../text/findInText.js";

export const MAX_FIND_ALL_HITS = 500;

export type FindHit = {
  tabIndex?: number;
  tabTitle?: string;
  rootFolderName?: string;
  relativePath?: string;
  fileHandle?: FileSystemFileHandle;
  displayPath: string;
  line: number;
  offset: number;
  length: number;
  preview: string;
};

export function collectHitsInTabs(
  tabs: readonly { title: string; content: string }[],
  needle: string,
  caseSensitive: boolean,
  wholeWord: boolean,
): FindHit[] {
  const hits: FindHit[] = [];
  if (!needle) return hits;
  for (let ti = 0; ti < tabs.length; ti++) {
    const content = tabs[ti]!.content;
    let from = 0;
    while (hits.length < MAX_FIND_ALL_HITS) {
      const i = findNextIndex(content, needle, from, caseSensitive, wholeWord);
      if (i < 0) break;
      const line = content.slice(0, i).split(/\r\n|\n|\r/).length;
      const lineStart = Math.max(content.lastIndexOf("\n", i - 1), content.lastIndexOf("\r", i - 1)) + 1;
      let lineEnd = content.indexOf("\n", i);
      const crEnd = content.indexOf("\r", i);
      if (lineEnd < 0 || (crEnd >= 0 && crEnd < lineEnd)) lineEnd = crEnd;
      const preview = content.slice(lineStart, lineEnd < 0 ? content.length : lineEnd).slice(0, 200);
      hits.push({
        tabIndex: ti,
        tabTitle: tabs[ti]!.title,
        displayPath: tabs[ti]!.title,
        line,
        offset: i,
        length: needle.length,
        preview,
      });
      from = i + Math.max(1, needle.length);
    }
  }
  return hits;
}
